module.exports = __webpack_public_path__ + "img/Feuilles_de_style_en_cascade.c26a73b4.png";